import { j as i } from "../../../node_modules/react/jsx-runtime.js";
import o from "./CardInput.module.scss.js";
import z from "../../atoms/Checkbox/Checkbox.js";
import { clsx as N } from "../../../node_modules/clsx/dist/clsx.m.js";
import { Avatar as P } from "../../atoms/Avatars/Avatar.js";
import { FeaturedIcon as R } from "../../atoms/FeaturedIcon/FeaturedIcon.js";
import { Radio as S } from "../../atoms/Radio/Radio.js";
import D from "../../atoms/Switch/Switch.js";
const H = ({
  id: j,
  testId: w,
  readonly: t,
  label: u,
  description: f,
  indeterminate: I,
  active: e,
  inputType: c,
  avatar: d,
  icon: x,
  prefix: l,
  height: k = "auto",
  disabled: s,
  onChange: r
}) => {
  const p = (m) => r == null ? void 0 : r(m.target.checked), A = () => l || (d ? /* @__PURE__ */ i.jsx(
    P,
    {
      imageSrc: d,
      imageAlt: "avatar",
      size: "l"
    }
  ) : x ? /* @__PURE__ */ i.jsx(
    R,
    {
      size: "sm",
      iconName: x
    }
  ) : null), a = () => {
    const m = {
      id: j,
      label: u,
      description: f,
      active: e,
      disabled: s,
      direction: "right"
    };
    if (c === "switch")
      return /* @__PURE__ */ i.jsx(
        D,
        {
          ...m,
          disabled: s || t,
          onChange: (E, b) => {
            r == null || r(b);
          }
        }
      );
    if (c === "radio")
      return /* @__PURE__ */ i.jsx(
        S,
        {
          ...m,
          width: "100%",
          disabled: s || t,
          onChange: p
        }
      );
    if (c === "checkbox")
      return /* @__PURE__ */ i.jsx(
        z,
        {
          ...m,
          disabled: s || t,
          indeterminate: I,
          onChange: p
        }
      );
  };
  return /* @__PURE__ */ i.jsxs(
    "div",
    {
      className: N(
        o.cardInputContainer,
        f && u ? "items-start" : "items-center",
        s || t ? "cursor-not-allowed" : "cursor-pointer",
        {
          [o.active]: e,
          [o.disabled]: s,
          [o.readonly]: t,
          [o.readonlyActive]: t && e
        }
      ),
      style: { height: k },
      role: "button",
      onClick: () => r == null ? void 0 : r(!e),
      onKeyDown: () => r == null ? void 0 : r(!e),
      tabIndex: 0,
      "data-testid": w,
      children: [
        A(),
        a()
      ]
    }
  );
};
export {
  H as default
};
//# sourceMappingURL=CardInput.js.map
